import { render } from "./GameScreen.vue?vue&type=template&id=ae46a0e6"
import script from "./GameScreen.vue?vue&type=script&lang=js"
export * from "./GameScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/bcfcareer25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__